/**
 * WC Wishlist & Back in Stock — refresh hook.
 *
 * The WC Wishlist app injects its heart icon into `.th_wl_col_btn` placeholders
 * on initial page load. When the collection grid is updated via AJAX (filtering,
 * sorting, infinite scroll / "Load more"), the newly inserted cards contain
 * empty placeholders that the app's initial scan never reached.
 *
 * The app exposes a global `window.$th_refreshWishlistItems()` function that
 * re-scans the DOM and injects icons into any new placeholders. This script
 * calls it in response to the theme's existing `on:facet-filters:updated`
 * event and the new `on:pagination:content-updated` event dispatched by
 * `assets/custom-pagination.js` after appended results.
 */
(function () {
  'use strict';

  function refreshWishlist() {
    if (typeof window.$th_refreshWishlistItems === 'function') {
      try {
        window.$th_refreshWishlistItems();
      } catch (err) {
        console.warn('Wishlist refresh failed:', err);
      }
    }
  }

  document.addEventListener('on:facet-filters:updated', refreshWishlist);
  document.addEventListener('on:pagination:content-updated', refreshWishlist);
})();
